<template>
  <div class="consume-range">
    <div class="empty-rank" v-if="!consumRange.length"></div>
    <div class="range-title" v-if="isOpenBaseText">
      {{ baseText }}
      <span class="total-prize" v-if="isOpenBaseText">
        <span class="prize">
          <span class="currence-symbol">￥</span>
          {{ money.toLocaleString() }}</span
        >
      </span>
    </div>
    <div class="range-title" v-if="isOpen">
      {{ title }}
      <span class="total-prize" v-if="isOpen">
        <span class="prize">
          <span class="currence-symbol">￥</span>
          {{ totalPrize.toLocaleString() }}</span
        >
      </span>
    </div>
    <div
      class="flex item flex flex-between item-center"
      v-for="(v, i) in consumRange"
      :key="i"
    >
      <div class="flex-1">
        <div>累计消费</div>
        <div class="range" v-if="!v.isUpperLimit">
          {{ v.min || 0 }}~{{ v.max || 0 }}元
        </div>
        <div v-else class="range">大于等于{{ v.min }}</div>
      </div>
      <div class="flex others flex-1 item-center">
        <div class="flex-1">
          <div>人数</div>
          <div class="count">88人</div>
        </div>
        <div class="flex-1 view-details flex flex-end">
          查看详情 <span class="hmicon icon-youjiantou"></span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    consumRange: {
      type: Array,
      default: () => []
    },
    isOpen: {
      type: Boolean,
      default: false
    },
    isOpenBaseText: {
      type: Boolean,
      default: false
    },
    baseText: {
      type: String,
      default: ""
    },
    title: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      totalPrize: 0,
      money: 0
    };
  },
  created() {},
  mounted() {},
  methods: {}
};
</script>

<style scoped lang="scss">
.consume-range {
  .item {
    font-size: 14px;
    background: #fff;
    border-bottom: 1px solid #f7f7f7;
    padding: 15px;
    color: #999;
    .others {
      width: 158px;
      flex-shrink: 0;
    }
    .count,
    .range {
      font-size: 16px;
      font-weight: bold;
      color: #2b2b2b;
      margin-top: 10px;
    }
    .view-details {
      font-size: 12px;
      .hmicon {
        font-size: 12px;
      }
    }
  }
}
.empty-rank {
  height: 50px;
  width: 100px;
}

.range-title {
  background: #fff;
  padding: 15px;
  font-weight: bold;
}
.total-prize {
  padding: 0 15px;
  background: #fff;
  color: #2d8cf0;
  .prize {
    .currence-symbol {
      font-size: 14px;
    }
    font-size: 18px;
  }
}
</style>
